import React from "react";
import numeral from "numeral";
import Panel from "../../Panel/Panel";

export default class BookingReviewAndBookSection extends React.Component {
  constructor(props) {
    super(props);

    this.onClickTerms = this.onClickTerms.bind(this);
  }

  render() {
    return (
      <div className="ReviewAndBookSection">
        <a id="ReviewAndBook" name="ReviewAndBook"></a>
        <Panel
          name="ReviewAndBook"
          expanded={this.props.expanded}
          onExpandCollapse={
            this.props.guestSectionValid && this.props.validPayment
              ? this.props.onExpandCollapse
              : null
          }
          header={this.renderHeader()}
          body={this.renderBody()}
        />
      </div>
    );
  }

  renderHeader() {
    return (
      <div>
        <span className="step-number">{this.props.step}</span>
        <h3>{I18n.t("terms_and_conditions")}</h3>
      </div>
    );
  }

  renderBody() {
    if (this.props.expanded) {
      return (
        <div className="expand-collapse-body">
          <form onSubmit={this.props.onBookNow}>
            <div className="YourReservation">
              {this.props.reservation_segments && this.props.reservation_segments.length ? 
              <div className="reservation-notes">
                <div className="form-group">
                  <label>{I18n.t("reservation_notes")}</label>
                  <textarea
                    className="form-control"
                    onChange={this.props.onChange}
                    name="reservationNotes"
                    placeholder={I18n.t("booking_flow_res_seg_notes")}
                    value={this.props.reservationNotes}
                  ></textarea>
                </div>
              </div>
              : null}

              <div className="TermsAndBookNow">
                <div className="TermsAndConditions" ref="TermsAndConditions">
                  <label onClick={this.onClickTerms}>
                    <input
                      type="checkbox"
                      name="accept_terms"
                      value={true}
                      checked={this.props.accept_terms}
                      onChange={this.props.onChange}
                    />{" "}
                    <span
                      onClick={this.props.onToggleTerms}
                      dangerouslySetInnerHTML={{
                        __html: I18n.t("i_agree_with_terms"),
                      }}
                    ></span>
                    <span
                      onClick={this.props.onTogglePrivacy}
                      dangerouslySetInnerHTML={{
                        __html: I18n.t("i_agree_with_privacy"),
                      }}
                    ></span>
                  </label>
                </div>

                <div className="Marketing" ref="Marketing">
                  <label>
                    <input
                      type="checkbox"
                      name="marketing_opt_in"
                      value={true}
                      checked={this.props.marketing_opt_in}
                      onChange={this.props.onChange}
                    />{" "}
                    {I18n.t("i_agree_with_marketing")}
                  </label>
                </div>

                <div className="BookButtonWrapper">
                  <button
                    type="submit"
                    className="book-btn"
                    disabled={
                      this.props.accept_terms == false ||
                      this.props.guestSectionIsComplete == false ||
                      this.props.paymentSectionIsComplete == false
                    }
                  >
                    {I18n.t("book_now")}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      );
    } else {
      return this.renderCollapsedDetail();
    }
  }

  renderCollapsedDetail() {
    if (
      this.props.reservation_segments &&
      this.props.reservation_segments.length > 0
    ) {
      return (
        <div className="collapsed-detail">
          <h5 style={{ display: "inline-block" }}>
            <strong>
              {I18n.t("reservation_total")}: {this.props.currency.symbol}
              {numeral(
                (this.props.reservation.total_amount *
                  this.props.currency.exchange_rate) /
                  100
              ).format(this.props.number_format)}
              &nbsp;
            </strong>
          </h5>
          <p style={{ display: "inline-block" }}>
            {I18n.t("with_taxes_and_fees")}
          </p>
          <h5>
            <strong>
              {I18n.t("due_today")}: {this.props.currency.symbol}
              {numeral(
                (this.props.reservation.amount_due_at_booking *
                  this.props.currency.exchange_rate) /
                  100
              ).format(this.props.number_format)}
            </strong>
          </h5>
        </div>
      );
    }
  }

  /**
   * Change handlers
   */

  onClickTerms() {
    this.props.onChange({
      target: {
        name: "accept_terms",
        value: !this.props.accept_terms,
      },
    });
  }

  /**
   * Helper functions
   */

  calculateGuestFees() {
    var total = 0;

    for (
      var i = 0, ilen = this.props.reservation_segments.length;
      i < ilen;
      i++
    ) {
      var reservation_segment = this.props.reservation_segments[i];
      if (
        reservation_segment.rate.rate_guest_types &&
        reservation_segment.rate.rate_guest_types.length
      ) {
        for (
          var j = 0, jlen = reservation_segment.rate.rate_guest_types.length;
          j < jlen;
          j++
        ) {
          var rate_guest_type = reservation_segment.rate.rate_guest_types[j];
          for (var k = 0, klen = this.props.guests.length; k < klen; k++) {
            var guest_type = this.props.guests[k];
            if (guest_type.id == rate_guest_type.guest_type_id) {
              if (
                guest_type.number_of_guests > rate_guest_type.guests_included
              ) {
                if (rate_guest_type.frequency == "recurring") {
                  var duration = reservation_segment.end_date.diff(
                    reservation_segment.start_date,
                    "days"
                  );
                  total =
                    total +
                    (guest_type.number_of_guests -
                      rate_guest_type.guests_included) *
                      rate_guest_type.additional_guest_price_amount *
                      duration;
                } else if (rate_guest_type.frequency == "one_time") {
                  total =
                    total +
                    (guest_type.number_of_guests -
                      rate_guest_type.guests_included) *
                      rate_guest_type.additional_guest_price_amount;
                }
              }
            }
          }
        }
      }
    }

    return total;
  }

  calculateSubtotalAmount() {
    var total = 0;
    for (
      var i = 0, ilen = this.props.reservation_segments.length;
      i < ilen;
      i++
    ) {
      var reservation_segment = this.props.reservation_segments[i];
      for (
        var j = 0, jlen = reservation_segment.rate.dates.length;
        j < jlen;
        j++
      ) {
        total = total + reservation_segment.rate.dates[j].amount;
      }
    }
    return total;
  }

  calculateTaxesAndFeesAmount() {
    var total = 0;
    for (
      var i = 0, ilen = this.props.reservation_segments.length;
      i < ilen;
      i++
    ) {
      var reservation_segment = this.props.reservation_segments[i];
      for (
        var j = 0, jlen = reservation_segment.rate.dates.length;
        j < jlen;
        j++
      ) {
        total =
          total +
          reservation_segment.rate.dates[j].taxes_and_fees_amount +
          this.calculateGuestFees();
      }
    }
    return total;
  }
}
